import {
  Gem,
  ShieldCheck,
  Target,
  PackageCheck,
  Tag,
  RefreshCcw,
  UserCheck,
  Globe,
  HeartHandshake,
  Compass,
} from "lucide-react";

export const WHY_CHOOSE_US_POINTS = [
  {
    title: "Premium Quality Products",
    testId: "why-premium-quality-products",
    icon: Gem,
    content:
      "We focus on sourcing quality agricultural and natural products with attention to freshness, specifications and buyer requirements.",
  },
  {
    title: "Trusted Sourcing",
    testId: "why-trusted-sourcing",
    icon: ShieldCheck,
    content:
      "We work with trusted farmers and suppliers to develop reliable sourcing channels for agricultural products.",
  },
  {
    title: "Quality-Focused Approach",
    testId: "why-quality-focused-approach",
    icon: Target,
    content:
      "Product quality, specifications and customer requirements are considered throughout sourcing and supply.",
  },
  {
    title: "Reliable Packaging",
    testId: "why-reliable-packaging",
    icon: PackageCheck,
    content:
      "Products are coordinated with suitable packaging according to product characteristics and buyer requirements.",
  },
  {
    title: "Competitive Pricing",
    testId: "why-competitive-pricing",
    icon: Tag,
    content:
      "We aim to provide competitive sourcing and pricing solutions based on the product, quantity and customer requirements.",
  },
  {
    title: "Reliable Supply",
    testId: "why-reliable-supply",
    icon: RefreshCcw,
    content:
      "Our sourcing and coordination approach focuses on maintaining reliable product supply according to agreed requirements.",
  },
  {
    title: "Customer-Centric Service",
    testId: "why-customer-centric-service",
    icon: UserCheck,
    content:
      "We understand buyer requirements and work to provide suitable product, quantity, packaging and sourcing solutions.",
  },
  {
    title: "International Business Support",
    testId: "why-international-business-support",
    icon: Globe,
    content:
      "We support international buyers with sourcing, export coordination and related trade requirements.",
  },
  {
    title: "Long-Term Relationships",
    testId: "why-long-term-relationships",
    icon: HeartHandshake,
    content:
      "We build long-term relationships based on trust, transparency, reliability and consistent service.",
  },
  {
    title: "India to Global Markets",
    testId: "why-india-to-global-markets",
    icon: Compass,
    content: "We aim to connect quality Indian agricultural products with buyers and markets worldwide.",
  },
];
